import { Cancel as CancelIcon } from "@mui/icons-material";
import { Button, Card, Space, Typography } from "antd";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";
import "./SubscriptionSuccessPage.css";

const { Title, Paragraph } = Typography;

const SubscriptionCancelledPage = () => {
  const history = useHistory();
  const lang = useSelector((state) => state.lang);

  const handleRetry = () => {
    // Close the modal and allow user to try again
    history.push("/chef/iam-a-chef/home");
  };

  const handleGoToDashboard = () => {
    history.push("/chef/iam-a-chef/home");
  };

  return (
    <div className="subscription-success-container">
      <div className="subscription-success-content">
        {/* Cancelled Header */}
        <Card className="subscription-success-card">
          <Space
            direction="vertical"
            size="large"
            style={{ width: "100%", textAlign: "center" }}
          >
            <CancelIcon
              style={{
                fontSize: "64px",
                color: "#faad14",
                marginBottom: "16px"
              }}
            />

            <Title level={2} style={{ color: "#faad14", margin: 0 }}>
              {t("subscription.cancelled_title", lang)}
            </Title>

            <Paragraph style={{ fontSize: "16px", margin: 0 }}>
              {t("subscription.cancelled_message", lang)}
            </Paragraph>

            <Space size="middle" style={{ marginTop: "24px" }}>
              <Button
                type="primary"
                size="large"
                onClick={handleRetry}
                style={{
                  backgroundColor: "#1890ff",
                  borderColor: "#1890ff",
                  minWidth: "140px"
                }}
              >
                {t("subscription.try_again", lang)}
              </Button>

              <Button size="large" onClick={handleGoToDashboard}>
                {t("subscription.return_to_dashboard", lang)}
              </Button>
            </Space>
          </Space>
        </Card>

        {/* Information Card */}
        <Card
          className="subscription-info-card"
          style={{ marginTop: "24px", textAlign: "left" }}
        >
          <Title level={4}>
            {t("subscription.cancelled_info_title", lang)}
          </Title>

          <Paragraph>
            {t("subscription.cancelled_info_message", lang)}
          </Paragraph>

          <ul style={{ paddingLeft: "20px", marginTop: "16px" }}>
            <li>{t("subscription.benefit_1", lang)}</li>
            <li>{t("subscription.benefit_2", lang)}</li>
            <li>{t("subscription.benefit_3", lang)}</li>
          </ul>
        </Card>
      </div>
    </div>
  );
};

export default SubscriptionCancelledPage;
